import { render, staticRenderFns } from "./AddInboundShipment.vue?vue&type=template&id=279adcba&"
import script from "./AddInboundShipment.vue?vue&type=script&lang=js&"
export * from "./AddInboundShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports